// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.farewellTitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 2.56vw;
  line-height: 3vw;
  text-align: center;

  color: #000000;
  padding-top: 3.39vw;
}
.farewellTitle span {
  font-weight: 500;
}
.farewellInfo {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 1.09vw;
  line-height: 1.46vw;
  margin-top: 0.73vw;
  /* or 133% */

  text-align: center;

  color: #545454;
}
.alignFarewell img {
  width: 65%;
}
.alignFarewell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.farewellBgColour {
  position: absolute;
  width: 100%;
  z-index: -9999;
  height: 36.6vw;
  left: 0;

  background: #f5faff;
}
.farewellContainer {
  margin-top: 4.39vw;
  position: relative;
  margin-bottom: 4.5vw;
}
.farewellTitle_mobile {
  display: none;
}

@media only screen and (max-width: 767px) {
  .farewellBgColour {
    height: 13rem;
  }
  .farewellTitle_mobile {
    display: block;
    color: #000;
    font-size: 1.1rem;
    font-weight: 400;
    margin-top: 1rem;
  }

  .farewellTitle_mobile span {
    color: #000;
    font-size: 1.1rem;
    font-weight: bold;
  }

  .farewellTitle {
    display: none;
  }

  .farewellInfo {
    font-size: 0.9rem;
    line-height: 1.5;
    width: 90%;
  }

  .alignFarewell img {
    width: 80%;
    margin-top: -1.2rem;
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/WebHomePage/Farewell/Farewell.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;EAElB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;;EAEZ,kBAAkB;;EAElB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,cAAc;EACd,OAAO;;EAEP,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":[".farewellTitle {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 2.56vw;\n  line-height: 3vw;\n  text-align: center;\n\n  color: #000000;\n  padding-top: 3.39vw;\n}\n.farewellTitle span {\n  font-weight: 500;\n}\n.farewellInfo {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 1.09vw;\n  line-height: 1.46vw;\n  margin-top: 0.73vw;\n  /* or 133% */\n\n  text-align: center;\n\n  color: #545454;\n}\n.alignFarewell img {\n  width: 65%;\n}\n.alignFarewell {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.farewellBgColour {\n  position: absolute;\n  width: 100%;\n  z-index: -9999;\n  height: 36.6vw;\n  left: 0;\n\n  background: #f5faff;\n}\n.farewellContainer {\n  margin-top: 4.39vw;\n  position: relative;\n  margin-bottom: 4.5vw;\n}\n.farewellTitle_mobile {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .farewellBgColour {\n    height: 13rem;\n  }\n  .farewellTitle_mobile {\n    display: block;\n    color: #000;\n    font-size: 1.1rem;\n    font-weight: 400;\n    margin-top: 1rem;\n  }\n\n  .farewellTitle_mobile span {\n    color: #000;\n    font-size: 1.1rem;\n    font-weight: bold;\n  }\n\n  .farewellTitle {\n    display: none;\n  }\n\n  .farewellInfo {\n    font-size: 0.9rem;\n    line-height: 1.5;\n    width: 90%;\n  }\n\n  .alignFarewell img {\n    width: 80%;\n    margin-top: -1.2rem;\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
